<div *ngFor="let suggested of mappedSuggestedDemos(); index as i" class="suggested-demo">
  <div class="selected-demo">
    <span>{{ suggested.asset }}</span>
  </div>
  <dx-select-box
    label="Behavior"
    labelMode="floating"
    stylingMode="outlined"
    [dataSource]="suggestedBehaviors"
    valueExpr="value"
    displayExpr="label"
    [value]="suggested.behavior"
    (valueChange)="updateSuggestedDemo($event, i)"
  >
  </dx-select-box>
  <mat-icon svgIcon="minus-16" aria-label="Delete suggested demo" (click)="deleteSuggestedDemo(i)"></mat-icon>
</div>
<form *ngIf="filteredAssets().length" class="suggested-demo" [formGroup]="newSuggestedFormGroup">
  <dx-select-box
    label="Demo"
    labelMode="floating"
    stylingMode="outlined"
    [dataSource]="filteredAssets()"
    valueExpr="id"
    displayExpr="displayValue"
    [searchEnabled]="true"
    formControlName="demoId"
  >
  </dx-select-box>
  <dx-select-box
    label="Behavior"
    labelMode="floating"
    stylingMode="outlined"
    [dataSource]="suggestedBehaviors"
    valueExpr="value"
    displayExpr="label"
    formControlName="behavior"
  >
  </dx-select-box>
</form>
